const settings = {
    svg: '<svg style="width:1.00rem; height:1.00rem;" viewBox="0 0 16 16"><path d="M8 11a3 3 0 1 1 0-6 3 3 0 0 1 0 6m5.3-5.8 1.1-2.1L13 1.7l-2.1 1.1a3.58 3.58 0 0 0-1.1-.4L9 0H7l-.8 2.3a4.18 4.18 0 0 0-1 .4L3.1 1.6 1.6 3.1l1.1 2.1a4.18 4.18 0 0 0-.4 1L0 7v2l2.3.8c.1.4.3.7.4 1.1L1.6 13 3 14.4l2.1-1.1a3.58 3.58 0 0 0 1.1.4L7 16h2l.8-2.3c.4-.1.7-.3 1.1-.4l2.1 1.1 1.4-1.4-1.1-2.1a3.58 3.58 0 0 0 .4-1.1L16 9V7l-2.3-.8a4.18 4.18 0 0 0-.4-1"/></svg>',
};

export { settings as default };
